import React from 'react';

const NetworkContext = React.createContext(null);

export default NetworkContext;
